import { render, staticRenderFns } from "./General.vue?vue&type=template&id=dba47d5a&scoped=true&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"
import style0 from "./General.vue?vue&type=style&index=0&id=dba47d5a&prod&scoped=true&lang=scss&"
import style1 from "./General.vue?vue&type=style&index=1&id=dba47d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba47d5a",
  null
  
)

export default component.exports